// src/extenders/search-modal.js
var SearchModal = class extends HTMLElement {
  constructor() {
    super();
    const openButton = document.querySelector(".js-search-open");
    const closeButton = document.querySelector(".js-search-close");
    const searchOverlay = document.querySelector(".search-overlay");
    if (openButton && closeButton && searchOverlay) {
      openButton.addEventListener("click", () => {
        const searchInputElement = searchOverlay.querySelector(
          ".search__text-input"
        );
        searchInputElement.focus();
        searchOverlay.classList.add("js-visible");
      });
      closeButton.addEventListener("click", () => {
        searchOverlay.classList.remove("js-visible");
      });
    }
  }
};
if (customElements.get("search-modal") === void 0) {
  customElements.define("search-modal", SearchModal);
}
